import React, { useState, useEffect } from 'react';
import { User } from '../../assets/icons';
import '../../assets/css/elements/live-visitor-counter.css';

const LiveVisitorCounter = () => {
    const [count, setCount] = useState(284);
    
    useEffect(() => {
        // Simulate slight variations in user count to create a "live" effect
        const interval = setInterval(() => {
            // Random fluctuation between -2 and +5 users
            const change = Math.floor(Math.random() * 8) - 2;
            // Ensure count doesn't go below a minimum threshold
            setCount(prev => Math.max(245, prev + change));
        }, 5000);
        
        return () => clearInterval(interval);
    }, []);
    
    return (
        <div className="live-visitor-counter">
            <img src={User} alt="Active users" />
            <span>{count} users online</span>
        </div>
    );
};

export default LiveVisitorCounter;